import { VDBText } from "@components/atoms";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { TooltipTextProps } from "./types";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";

const TooltipText = ({
  text,
  tooltip,
  color,
  type,
  enableTooltip,
  isAvailableStatusView = false,
  defaultWidth,
  textAlignment,
  hoverColor,
}: TooltipTextProps) => {
  const [hovered, setHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const theme = useTheme();
  const typography = useTypographyStore();
  const handleMouseEnter = (event) => {
    const { clientX } = event;
    const rect = event.target.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: clientX,
    });
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const normalizedWidth =
    defaultWidth == null || defaultWidth === ""
      ? "auto"
      : typeof defaultWidth === "string" && defaultWidth.endsWith("px")
      ? defaultWidth
      : `${defaultWidth}px`;

  return (
    <ToolTipContainer>
      <TextContainer
        defaultWidth={normalizedWidth}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isAvailableStatusView ? (
          <AvailabilityDotLarge bgColor={color} />
        ) : (
          <VDBText
            color={hovered ? hoverColor : color}
            type={type}
            numberOfLines={1}
            ellipsizeMode="tail"
            textAlign={textAlignment}
          >
            {text}
          </VDBText>
        )}
      </TextContainer>
      {hovered &&
        enableTooltip &&
        ReactDOM.createPortal(
          <ToolTip top={tooltipPosition.top} left={tooltipPosition.left}>
            <ToolTipArrow />
            <ToolTipText>
              <VDBText
                color={theme["core-01"]}
                type={typography["Minor-R"]}
                textAlign={"center"}
              >
                {tooltip}
              </VDBText>
            </ToolTipText>
          </ToolTip>,
          document.body
        )}
    </ToolTipContainer>
  );
};

const AvailabilityDotLarge = styled.View<any>`
  height: 13px;
  width: 13px;
  border-radius: 16px;
  border: 1px;
  border-color: ${({ theme }) => theme["cont-00"]};
  background-color: ${({ bgColor }) => bgColor};
`;

const ToolTipContainer = styled.View`
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.View<{
  defaultWidth: string;
}>`
  position: relative;
  overflow: hidden;
  width: ${({ defaultWidth }) => defaultWidth};
`;

const ToolTip = styled.View<{
  top: number;
  left: number;
}>`
  align-items: center;
  z-index: 1000;
  position: absolute;
  transform: translateX(-50px);
  top: ${({ top }) => top};
  left: ${({ left }) => left};
`;

const ToolTipArrow = styled.View`
  width: 0px;
  height: 0px;
  border-left-width: 8px;
  border-right-width: 8px;
  border-bottom-width: 12px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: ${({ theme }) => theme["core-06"]};
  margin-bottom: -1px;
`;

const ToolTipText = styled.View`
  background-color: ${({ theme }) => theme["core-06"]};
  padding: ${SpaceType.Basic}px;
  max-width: 343px;
  min-width: 100px;
  border-radius: ${SpaceType.Basic}px;
`;

export default TooltipText;
